import axios from 'axios';
import IntlMessages from '../../util/IntlMessages';
import * as tools from '../../util/tools';

const callApi = async (serviceName, body, headers = {}) => {
  let url = tools.getHttpRequestUrl(serviceName);
  headers = tools.getHttpRequestHeader(headers);

  try {
    tools.logger(body);
    let response = await axios.post(url, body, { headers });
    tools.logger(response);
    return tools.getHttpResponseSuccess(response);
  } catch (error) {
    return {
      status: false,
      message: <IntlMessages id="sorrySomethingwentWrongPleaseTryAgain" />,
      data: [],
      errorCode: 0,
    };
  }
};

export default callApi;
